import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Logout from '../views/Logout.vue'
import todolist from '../views/todolist.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/todolist',
    name: 'todolist',
    component: todolist,
    meta: {
      requireAuth: true
    }
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  var currentUser = localStorage.getItem("loggeduser");
  var requireAuth = to.matched.some(record => record.meta.requireAuth);
  if (requireAuth && currentUser == 'false') next('login')
  else if (!requireAuth && currentUser == 'true') next();
  else next()
})

export default router